import { render, staticRenderFns } from "./RoofShape.html?vue&type=template&id=73c41516&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./RoofShape.scss?vue&type=style&index=0&id=73c41516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c41516",
  null
  
)

export default component.exports